module.exports = __webpack_public_path__ + "img/settings.184822a7.svg";